import styled, {css} from 'styled-components';
import * as globals from '../css/globals.styles';
import WBIcon from './elements/WBIcon';

export const WIDTH = 254;
export const NARROW_WIDTH = 56;
const DISTANCE_FROM_CONTENT = 20;

export const FloatingContainer = styled.div<{active: boolean; narrow: boolean}>`
  position: sticky;
  top: 100px;
  height: 0;
  width: ${WIDTH}px;
  margin-left: -${WIDTH + DISTANCE_FROM_CONTENT}px;
  z-index: 1;
  padding-left: 24px;

  transition: visibility 0.5s, opacity 0.5s;
  ${props =>
    props.active
      ? css`
          visibility: visible;
          opacity: 1;
        `
      : css`
          visibility: hidden;
          opacity: 0;
        `}

  ${props =>
    props.narrow &&
    css`
      width: ${NARROW_WIDTH}px;
      margin-left: -${NARROW_WIDTH + DISTANCE_FROM_CONTENT}px;
    `}
`;

export const Image = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 12px;
`;

export const Icon = styled(WBIcon)<{starred?: boolean}>`
  color: ${props =>
    props.starred != null ? globals.heartColor : globals.gray};
  font-size: 24px;
  padding: 0 4px;
  margin-right: 12px;
`;

export const Row = styled.div<{
  light?: boolean;
  backLink?: boolean;
  active?: boolean;
}>`
  display: flex;
  align-items: center;
  padding: 6px 0;
  cursor: pointer;

  ${props =>
    props.light &&
    css`
      color: ${globals.lightGray};
      &:hover {
        color: ${globals.gray};
      }
    `}
  ${props =>
    props.backLink &&
    css`
      margin-top: 12px;
    `}
    
  ${props =>
    props.active &&
    css`
      ${Icon} {
        color: ${globals.heartColor};
      }
    `}
  ${props =>
    props.active === false &&
    css`
      &:hover ${Icon} {
        color: ${globals.heartColor};
      }
    `}
`;

export const Header = styled.div`
  padding-top: 18px;
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 8px;
  border-bottom: 1px solid ${globals.veryLightGray};
  margin-bottom: 12px;

  ${Row} {
    padding: 4px 0;
  }
`;
